import ApiModule from './index'
import BaseModel from '../../base/BaseModel'
const MODULE = ApiModule.OSS

export class OssImagesBase64 extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = MODULE
		this.url = '/tfile/uploadImagesBase64'
		this.desc = '上传图片Base64'
	}
}
